import React, { useState } from 'react'
import { Button } from '~/components/_atoms/index'
import { Modal } from '~/components/_layouts/index'
import { useTranslation } from '~/hooks/useTranslation'

const DownloadFeedbacksModal = () => {
  const { t } = useTranslation('DownloadFeedbacks')
  const [open, setOpen] = useState(false)
  const handleConfirm = () => {
    window.open('/coach_services/feedback.pdf', '_blank')
    setOpen(false)
  }
  if (!open)
    return (
      <Button color="secondary" onClick={() => setOpen(true)}>
        {t('cta', { defaultValue: 'Download All Feedbacks' })}
      </Button>
    )
  return (
    <Modal
      open={open}
      onClose={() => setOpen(false)}
      title={t('cta', { defaultValue: 'Download All Feedbacks' })}
      size="md"
      variant="secondary"
      actions={[
        <Button
          key="cancel"
          variant="ghost"
          color="secondary"
          onClick={() => setOpen(false)}
        >
          {t('cancel', { defaultValue: 'Cancel' })}
        </Button>,
        <Button key="confirm" color="secondary" onClick={handleConfirm}>
          {t('continue', { defaultValue: 'Continue' })}
        </Button>,
      ]}
    >
      <div>
        <p>
          {t('modal_content', {
            defaultValue:
              'You can download all of your coach feedbacks into one document, but this process could take a few minutes. To download individual documents or attachments that you sent or received from your coach, please download those separately.',
          })}
        </p>
      </div>
    </Modal>
  )
}

export default DownloadFeedbacksModal
